import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RiferimentoPAModalComponent } from './riferimento-pa-modal';

export const RiferimentoPAModalModule: string = ng
    .module('riferimento-pa-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('riferimentoPAModalComponent', RiferimentoPAModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/riferimento-pa-modal/riferimento-pa-modal.module.ts